module.exports = __WEBPACK_EXTERNAL_MODULE_dJD___;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"redux","commonjs2":"redux","amd":"redux","root":"Redux"}
// module id = dJD+
// module chunks = 0